import authApi from "./auth.api";
import { useEffect, useRef, useState } from "react";
import { SessionInfo } from "./auth.typer";
import { logFrontendToBackend } from "../feil/logFrontendToBackend";
import { ApiError } from "../api/api.utils";
import useAuthentication from "./useAuthentication";

/**
 * Håndterer refresh av sesjoner slik at man ikke blir logget ut.
 * Baserer seg på infomasjon fra wonderwall sitt /oauth2/session endepunkt som sier noe om når man kan refreshe
 * access tokenet.
 */
const SessionHandler = () => {
  const { userInfo } = useAuthentication();
  const [sessionInfo, setSessionInfo] = useState<SessionInfo>();
  const isRefreshingRef = useRef(false);

  useEffect(() => {
    if (userInfo) {
      authApi
        .getSessionInfo()
        .then((sessionInfo) => setSessionInfo(sessionInfo))
        .catch(handleError);
    }
  }, [userInfo]);

  useEffect(() => {
    const nextAutoRefreshInSeconds = sessionInfo?.tokens.next_auto_refresh_in_seconds;
    if (nextAutoRefreshInSeconds != undefined) {
      const refreshDelay = (nextAutoRefreshInSeconds + 1) * 1000;

      const sessionRefreshTimer = setTimeout(
        async () => {
        if (isRefreshingRef.current) {
          return;
        }

        isRefreshingRef.current = true;
        try {
          const newSessionInfo = await authApi.refreshSession();
          setSessionInfo(newSessionInfo);
        } catch (error) {
          handleError(error);
        } finally {
          isRefreshingRef.current = false;
        }
      }, refreshDelay);
      return () => {
        clearTimeout(sessionRefreshTimer);
      };
    }
  }, [
    sessionInfo?.tokens.refreshed_at,
    sessionInfo?.tokens.next_auto_refresh_in_seconds,
  ]);

  return null;
};
function handleError(error: unknown) {
  if (error instanceof Error) {
    if (error instanceof ApiError && error.status == 401) {
      return;
    }
    logFrontendToBackend(error);
  }
}

export default SessionHandler;
